import React from 'react';
import { Card, CardBody, CardHeader, Col, Row, Badge, Spinner } from 'reactstrap';
import { H5, H6 } from '../../../AbstractElements';
import { Users, UserCheck, UserX, Activity } from 'react-feather';

const UserRVOPVStats = ({ usersRVOPV = [], loading }) => {
  // Tính toán thống kê từ dữ liệu thực
  const getStats = () => {
    if (!usersRVOPV || usersRVOPV.length === 0) {
      return {
        totalUsers: 0,
        activeUsers: 0,
        inactiveUsers: 0,
        newUsers: 0
      };
    }

    const totalUsers = usersRVOPV.length;
    const activeUsers = usersRVOPV.filter(user => user.isActive !== false).length;
    const inactiveUsers = totalUsers - activeUsers;
    
    // Users tạo trong 30 ngày gần đây
    const thirtyDaysAgo = new Date();
    thirtyDaysAgo.setDate(thirtyDaysAgo.getDate() - 30);
    const newUsers = usersRVOPV.filter(user => {
      const createdDate = new Date(user.createdAt);
      return createdDate >= thirtyDaysAgo;
    }).length;

    return {
      totalUsers,
      activeUsers,
      inactiveUsers,
      newUsers
    };
  };

  const stats = getStats();

  const statsData = [
    {
      title: 'Tổng User RVOPV',
      value: stats.totalUsers,
      color: 'primary',
      icon: Users,
      description: 'Tổng số user trong hệ thống'
    },
    {
      title: 'User Hoạt Động',
      value: stats.activeUsers,
      color: 'success',
      icon: UserCheck,
      description: 'User đang hoạt động'
    },
    {
      title: 'User Không Hoạt Động',
      value: stats.inactiveUsers,
      color: 'danger',
      icon: UserX,
      description: 'User đã ngừng hoạt động'
    },
    {
      title: 'User Mới (30 ngày)',
      value: stats.newUsers,
      color: 'warning',
      icon: Activity,
      description: 'User đăng ký trong 30 ngày'
    }
  ];

  if (loading) {
    return (
      <Col xxl="12" className="box-col-12">
        <Card>
          <CardBody className="d-flex justify-content-center align-items-center" style={{ height: '200px' }}>
            <div className="text-center">
              <Spinner color="primary" />
              <p className="mt-2 mb-0">Đang tải dữ liệu User RVOPV...</p>
            </div>
          </CardBody>
        </Card>
      </Col>
    );
  }

  return (
    <Col xxl="12" className="box-col-12">
      <Card>
        <CardHeader className="card-no-border">
          <H5>Thống Kê User RVOPV</H5>
        </CardHeader>
        <CardBody>
          <Row className="g-3">
            {statsData.map((item, index) => {
              const Icon = item.icon;
              return (
                <Col key={index} xl="3" md="6" sm="6" className="box-col-6">
                  <Card className="stat-widget">
                    <CardBody>
                      <div className="d-flex align-items-center justify-content-between">
                        <div className="d-flex flex-column justify-content-center" style={{ minWidth: 0, flex: 1 }}>
                          <span className="f-light f-w-500 f-14 d-block mb-2">{item.title}</span>
                          <H6 attrH6={{ className: 'mb-0' }}>
                            <Badge color={item.color} className="badge-lg">
                              {item.value}
                            </Badge>
                          </H6>
                          <small className="text-muted mt-1">{item.description}</small>
                        </div>
                        <div 
                          className={`bg-${item.color} rounded d-flex align-items-center justify-content-center`} 
                          style={{ width: '48px', height: '48px', flexShrink: 0 }}
                        >
                          <Icon size={22} className="text-white" />
                        </div>
                      </div>
                    </CardBody>
                  </Card>
                </Col>
              );
            })}
          </Row>
        </CardBody>
      </Card>
    </Col>
  );
};

export default UserRVOPVStats;

